import React, { useMemo, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { CommonSelect, CommonTabs } from '@/components/common'
import { useThemeController } from '@/styles'
import { THEME_COLOR_OPTIONS } from '@/styles/theme'
import {
  ApiDemo,
  CommonComponents,
  DonationComponents,
  TypographyComponents,
} from '@/components/playground'

export const PlaygroundPage = () => {
  const [value, setValue] = useState(0)
  const { primaryHex, setPrimaryHex } = useThemeController()

  const colorOptions = useMemo(() => THEME_COLOR_OPTIONS, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%', backgroundColor: '#fafafa', minHeight: '100vh' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Box sx={{ maxWidth: 1200, margin: '0 auto', px: 0.5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant='h4'
              sx={{ py: 2, color: 'primary.main', fontWeight: 'bold' }}
            >
              Development Playground
            </Typography>
            <CommonSelect
              id='theme-color-select'
              label='Theme'
              value={primaryHex}
              optionText='name'
              optionValue='id'
              enableSort={false}
              options={colorOptions}
              fullWidth={false}
              onChange={hex => setPrimaryHex(hex)}
              placeholder='Select color'
            />
          </Box>

          <CommonTabs
            id='playground'
            value={value}
            onChange={handleChange}
            tabs={[
              { label: 'Common Components', content: <CommonComponents /> },
              { label: 'App Components', content: <DonationComponents /> },
              { label: 'Typography', content: <TypographyComponents /> },
              { label: 'API Demo', content: <ApiDemo /> },
            ]}
          />
        </Box>
      </Box>
    </Box>
  )
}
